export default function ({ store, redirect, route }) {
  const isLoggedIn = store.getters['auth/loggedIn']

  if (!isLoggedIn) {
    return redirect('/auth')
  }
}
